import React from "react";
import { Button, Icon, TextInput } from "react-materialize";
import axios from "axios";
import { connect } from "react-redux";

import "./GeopgraphyTable.styles.scss";
import Pagination from "../../../layout/Pagination";
import CreateModal from "./components/CreateModal/CreateModal";
import TableWorker from "./components/TableWorker/TableWorker";
import Dropdown from "./components/Dropdown/Dropdown";
import RegionSelectionBelt from "./components/RegionSelectionBelt";
import { normalizeString } from "./components/utils/normalizeString";
import Loader from "../Loader";

class GeopgraphyTable extends React.Component {
  constructor() {
    super();
    this.state = {
      showCreateModal: false,

      data_fetching: true,
      fetching_table_data: true,

      total: "",
      page: "",
      limit: "",
      search: "",
      table_data: [],
      selected_option: [],
      fseId: "",
      fse: [],

      selected_filter: "",
      agencies: [],

      reset: true,
      selectedZone: {
        icon: "gps_fixed",
        lable: "Manage Spot",
        id: "spots",
        createId: "spot",
        parent: "agency_name",
        parentId: "agency",
        createParentId: "agency",
        children: null,
        parentPlaceHolder: "Distributor",
      },
      spots: [],
      agency: [],
      territories: [],
      areas: [],
      regions: [],
      clusters: [],
      zoneMapping: {},
      page_size: 150,
      loadingData: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.currentPage !== prevProps.currentPage ||
      this.props.currentLimit !== prevProps.currentLimit
    ) {
      //this.getZoneData();
      this.getZoneData(this.state.selectedZone.id);
    }
  }

  reset_toggle = () => {
    this.setState({ reset: !this.state.reset });
  };

  componentDidMount() {
    // this.loadFSE();
    this.getZoneData("spots");
    //this.loadAgencies();
    this.loadZonesForMapping(this.state.selectedZone["parentId"]);
    // this.loadZonesForMapping("agency");
    // this.loadZonesForMapping("areas");
    // this.loadZonesForMapping("territories");
  }

  handleMDOSave = () => {};
  loadZonesForMapping = (zone) => {
    //console.log("hit madafaqa");
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/organizations/api/v1/${zone}`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
      .then((res) => {
        this.setState({
          zoneMapping: { ...this.state.zoneMapping, [zone]: res.data.data },
        });
      })
      .catch((err) => console.log(err));
  };

  getZoneData = (zone) => {
    this.setState({ loadingData: true });
    axios
      .get(
        `${
          process.env.REACT_APP_API_URL
        }/api/organizations/api/v1/${zone}?module=hierarchy&page_index=${
          this.props.currentPage
        }&page_size=${parseInt(this.props.currentLimit)}&search_term=${
          this.state.search
        }${this.state.selected_filter}`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
      .then((res) => {
        return this.setState({
          total: res.data.count,
          page: res.data.page,
          limit: res.data.limit,
          table_data: res.data.data,
          [zone]: res.data.data,
          fetching_table_data: false,
          data_fetching: false,
          loadingData: false,
        });
      })
      .catch((err) => {
        this.setState({
          data_fetching: false,
          fetching_table_data: false,
          loadingData: false,
        });
        console.log(err);
      });
  };
  showCreateModal = () => this.setState({ showCreateModal: true });
  hideCreateModal = () => this.setState({ showCreateModal: false });

  handleAgencyChange = (selected_option) => {};

  handleFilterChange = (selected_option) => {
    // this.setState({ fetching_table_data: true });
    // this.setState({ selected_option });

    let filter =
      selected_option !== null
        ? selected_option
            .map(
              (option) =>
                `&${this.state.selectedZone["createParentId"]}=${option.id}`
            )
            .join("")
        : "";

    this.setState({ selected_filter: filter }, () => {
      this.getZoneData(this.state.selectedZone.id);
      // this.loadFSE();
      // this.getData();
    });
  };

  handleSearch = (event) => {
    this.setState({ search: event.target.value }, () =>
      setTimeout(() => this.getZoneData(this.state.selectedZone.id), 250)
    );
  };

  handleOptionChange = (selected_option) => {
    this.setState({ fetching_table_data: true });
    this.setState({ selected_option });
    let filter = typeof selected_option !== undefined ? selected_option.id : "";

    this.setState({ fseId: filter }, () => this.getData());
  };

  loadAgencies = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/organizations/api/v1/agency`, {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      })
      .then((res) => {
        this.setState({
          agencies: res.data.data,
        });
      })
      .catch((err) => console.log(err));
  };

  callBackFromSelectionBelt = (e) => {
    console.log(e);
    this.setState({ selectedZone: { ...e }, selected_filter: "" });
    this.getZoneData(e.id);
    if (e["parentId"] && !this.state.zoneMapping[e["parentId"]])
      this.loadZonesForMapping(e["parentId"]);
  };

  render() {
    const { data_fetching, fetching_table_data } = this.state;
    const selectedZoneMember = this.state.selectedZone["id"];
    console.log(selectedZoneMember);
    // const isAllZoneMappingAvailable =
    //   Object.keys(this.state.zoneMapping).length === 4 &&
    //   this.state.zoneMapping["spots"].length > 0 &&
    //   this.state.zoneMapping["agency"].length > 0 &&
    //   this.state.zoneMapping["areas"].length > 0 &&
    //   this.state.zoneMapping["territories"].length > 0;
    return (
      <div className="mdo-table-container">
        {data_fetching ? (
          <Loader />
        ) : (
          <>
            <div className="selection-belt">
              <RegionSelectionBelt callBack={this.callBackFromSelectionBelt} />
            </div>
            <div className="button-filter-search">
              <Button
                node="button"
                style={{
                  marginRight: "20px",
                  backgroundColor: "white",
                  borderRadius: "4px",
                  color: "#434364",
                  boxShadow: "1px 1px 0px 0px",
                  border: "1px solid rgb(226, 19, 110)",
                  height: "40px",
                  textTransform: "none",
                }}
                waves="light"
                onClick={() => {
                  this.showCreateModal();
                  this.reset_toggle();
                }}
              >
                <Icon
                  style={{ color: "rgb(226, 19, 110)", fontWeight: 700 }}
                  left
                >
                  add
                </Icon>
                Create {normalizeString(this.state.selectedZone["createId"])}
              </Button>
              <CreateModal
                handleHide={this.hideCreateModal}
                show={this.state.showCreateModal}
                reset={this.state.reset}
                selectedZone={this.state.selectedZone}
              />
              <div className="grouped-filter-search">
                {this.state.selectedZone["id"] !== "regions" &&
                  this.state.zoneMapping[
                    this.state.selectedZone["parentId"]
                  ] && (
                    <div className="filter-by-agency">
                      <Dropdown
                        title={`Filter by ${this.state.selectedZone["parentId"]}`}
                        items={
                          this.state.zoneMapping[
                            this.state.selectedZone["parentId"]
                          ]
                        }
                        multiselect
                        onChange={this.handleFilterChange}
                      />
                    </div>
                  )}
                {/* <div className="filter-by-agency">
                  <Dropdown
                    title="Filter By"
                    items={this.state.fse}
                    onChange={this.handleOptionChange}
                  />
                </div> */}
                <div className="searchbox">
                  <TextInput
                    id="TextInput-4"
                    placeholder={`Search ${this.state.selectedZone["id"]}`}
                    icon="search"
                    onChange={this.handleSearch}
                  />
                </div>
              </div>
            </div>

            <Pagination
              page={"geography"}
              currentPage={this.props.currentPage}
              total={this.state.total}
              limit={this.props.currentLimit}
            />

            {fetching_table_data ? (
              <span>Searching</span>
            ) : (
              <div className="worker-table">
                <table>
                  <thead>
                    <tr>
                      <th className="name">Code</th>
                      <th className="mdo-id">Name</th>
                      <th className="phone">
                        {this.state.selectedZone.id === "regions" ||
                        this.state.selectedZone.id === "clusters"
                          ? "Division"
                          : "District"}
                      </th>

                      {this.state.selectedZone["id"] === "agency" && (
                        <th className="mdo-id">Thana</th>
                      )}

                      {this.state.selectedZone["parent"] && (
                        <th className="fse">
                          {normalizeString(
                            this.state.selectedZone.parentPlaceHolder
                          )}
                        </th>
                      )}
                      {this.state.selectedZone["children"] && (
                        <th className="fse">
                          {normalizeString(
                            this.state.selectedZone.childrenPlaceHolder
                          )}
                        </th>
                      )}
                      {this.state.selectedZone["id"] === "agency" && (
                        <th className="fse">MA Wallet</th>
                      )}
                      <th
                        style={{ padding: 0, textAlign: "center", opacity: 0 }}
                      >
                        Manage
                      </th>
                    </tr>
                  </thead>
                  {this.state.loadingData && (
                    <div className="data-fetching-loader">
                      <Loader />
                    </div>
                  )}
                  <tbody style={{ opacity: !this.state.loadingData ? 1 : 0.6 }}>
                    {this.state.zoneMapping[
                      this.state.selectedZone["parentId"]
                    ] &&
                      this.state[selectedZoneMember].map((worker) => (
                        <TableWorker
                          key={worker.id}
                          data={worker}
                          handleDelete={() => {
                            this.getZoneData("spots");
                          }}
                          selectedZoneMember={this.state.selectedZone}
                          zoneMapping={this.state.zoneMapping}
                        />
                      ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  let currentLimit = state.paginationLimit.geography
    ? state.paginationLimit.geography.currentLimit
    : state.paginationLimit.default.currentLimit;

  let currentPage = state.page.geography
    ? state.page.geography.currentPage
    : state.page.default.currentPage;

  return { currentLimit, currentPage };
};

export default connect(mapStateToProps)(GeopgraphyTable);
